import { PageHeader } from "@/components/PageHeader";
export default function SelfInspectionPage() {
  return (
    <div className="flex flex-col bg-background">
      <PageHeader title="자주검사" />

      <main className="flex-1 p-6">
        <div className="container mx-auto">
          <p className="text-gray-600 dark:text-gray-400">
            This is self-inspection page
          </p>
        </div>
      </main>
    </div>
  );
}
